import { IconButton } from "@chakra-ui/button";
import { Box, Flex, HStack, Stack, Text } from "@chakra-ui/layout";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { Icon } from "../../components/Icon";
import { MainObjective } from "../../components/MainObjective";
import { ObjectiveList } from "../../components/ObjectiveList";
import { useStores } from "../../hooks/useStores";
import { isMobile } from "react-device-detect";
import ReactGA from "react-ga";
import { useEffect } from "react";

export const ClientObjectives: React.FC = observer(() => {
  const { session } = useStores();
  const history = useHistory();
  const { t } = useTranslation();

  // useEffect(() => {
  //   ReactGA.pageview("/client/objectives");
  // }, []);

  if (!session.user) {
    return <div />;
  }

  return (
    <Stack margin={"2rem"} gridGap={"2rem"}>
      <HStack marginBottom={"2rem"}>
        <IconButton
          aria-label="Back"
          icon={<Icon iconName={"HiArrowLeft"} />}
          variant={"ghost"}
          onClick={() => history.push("/client/board")}
        />
        <Stack>
          <Text fontSize="3xl">
            {t("screens.client.clientObjectives.title")}
          </Text>
        </Stack>
      </HStack>

      <Flex
        justifyContent={isMobile ? "" : "space-evenly"}
        flexDirection={isMobile ? "column" : "row"}
      >
        <Box w={isMobile ? "100%" : "30%"} p="4">
          <MainObjective
            userId={session.user?.id}
            isSubscriptionDeactivated={session.isSubscriptionDeactivated}
          />
        </Box>
        <Box w={isMobile ? "100%" : "30%"} p="4">
          <ObjectiveList
            userId={session.user?.id}
            isSubscriptionDeactivated={session.isSubscriptionDeactivated}
          />
        </Box>
      </Flex>
    </Stack>
  );
});
